/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Storage_Notice_PrefixInputs */

const en_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Embed 608/708 captioning directly into your video file. Videos with embedded captioning are stored on temporary storage for 14 days.`)
};

const fr_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incrustez les sous-titres 608/708 directement dans votre fichier video. Les videos avec sous-titres incrustes sont stockees temporairement pendant 14 jours.`)
};

const de_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Binden Sie 608/708-Untertitel direkt in Ihre Videodatei ein. Videos mit eingebetteten Untertiteln werden 14 Tage lang temporär gespeichert.`)
};

const it_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpora i sottotitoli 608/708 direttamente nel tuo file video. I video con sottotitoli incorporati vengono archiviati temporaneamente per 14 giorni.`)
};

const ru_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Встраивайте субтитры 608/708 непосредственно в видеофайл. Видео с встроенными субтитрами хранятся во временном хранилище в течение 14 дней.`)
};

const es_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore subtítulos 608/708 directamente en su archivo de video. Los videos con subtítulos incrustados se almacenan temporalmente durante 14 días.`)
};

const zh_cn2_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将 608/708 字幕直接嵌入到视频文件中。带有嵌入式字幕的视频将在临时存储空间保存 14 天。`)
};

const ja_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`608/708 字幕を動画ファイルに直接埋め込みます。字幕が埋め込まれた動画は、一時ストレージに 14 日間保存されます。`)
};

const hi_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अपनी वीडियो फ़ाइल में सीधे 608/708 कैप्शनिंग जोड़ें। कैप्शनिंग वाली वीडियो 14 दिनों के लिए अस्थायी स्टोरेज में रखी जाती हैं।`)
};

const pt_pt2_embed_captions_storage_notice_prefix = /** @type {(inputs: Embed_Captions_Storage_Notice_PrefixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incorpore legendas 608/708 diretamente no seu arquivo de vídeo. Os vídeos com legendas incorporadas são armazenados temporariamente por 14 dias.`)
};

/**
* | output |
* | --- |
* | "Embed 608/708 captioning directly into your video file. Videos with embedded captioning are stored on temporary storage for 14 days." |
*
* @param {Embed_Captions_Storage_Notice_PrefixInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_storage_notice_prefix = /** @type {((inputs?: Embed_Captions_Storage_Notice_PrefixInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Storage_Notice_PrefixInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_storage_notice_prefix(inputs)
	if (locale === "de") return de_embed_captions_storage_notice_prefix(inputs)
	if (locale === "it") return it_embed_captions_storage_notice_prefix(inputs)
	if (locale === "ru") return ru_embed_captions_storage_notice_prefix(inputs)
	if (locale === "es") return es_embed_captions_storage_notice_prefix(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_storage_notice_prefix(inputs)
	if (locale === "ja") return ja_embed_captions_storage_notice_prefix(inputs)
	if (locale === "hi") return hi_embed_captions_storage_notice_prefix(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_storage_notice_prefix(inputs)
	return en_embed_captions_storage_notice_prefix(inputs)
});